'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents),
    _reactPopper = require('react-popper'),
    _styles = require('../styles'),
    _themes = require('../themes'),
    _propTypes3 = require('../propTypes'),
    _componentTheme = require('./componentTheme'),
    _componentTheme2 = _interopRequireDefault(_componentTheme);

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var Styled = {
  div: {}
};
Styled.Manager = (0, _styledComponents2.default)(_reactPopper.Manager).withConfig({
  displayName: 'Tooltip__Manager'
})(['display:inline-block;']), Styled.div.tooltip = _styledComponents2.default.div.withConfig({
  displayName: 'Tooltip__tooltip'
})(['padding:3px 8px;opacity:', ';background:', ';border-radius:2px;box-shadow:0 2px 8px rgba(0,0,0,0.2);color:', ';font-family:', ';font-size:', ';font-weight:', ';-webkit-font-smoothing:antialiased;transform:translate( ', ',', ' );transition-property:opacity transform;transition-duration:', ';transition-timing-function:', ';'], function (props) {
  return props.sc.open ? 1 : 0;
}, function (props) {
  return props.theme.vstui.Tooltip_backgroundColor;
}, function (props) {
  return props.theme.vstui.Tooltip_color;
}, function (props) {
  return props.theme.vstui.Tooltip_fontFamily;
}, function (props) {
  return props.theme.vstui.Tooltip_fontSize;
}, function (props) {
  return props.theme.vstui.Tooltip_fontWeight;
}, function (props) {
  return props.sc.open ? 0 : -1 === props.sc.placement.indexOf('left') ? -1 === props.sc.placement.indexOf('right') ? 0 : '-2px' : '2px';
}, function (props) {
  return props.sc.open ? 0 : 0 === props.sc.placement.indexOf('top') ? '2px' : 0 === props.sc.placement.indexOf('bottom') ? '-2px' : 0;
}, function (props) {
  return props.theme.vstui.Tooltip_transitionDuration;
}, function (props) {
  return props.theme.vstui.Tooltip_transitionEasing;
});

var Tooltip = function (_PureComponent) {
  function Tooltip(props) {
    _classCallCheck(this, Tooltip);

    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    return _this.state = {
      open: !1
    }, _this.handleBlur = _this.handleBlur.bind(_this), _this.handleFocus = _this.handleFocus.bind(_this), _this.handleKeyDown = _this.handleKeyDown.bind(_this), _this.handleTargetMouseEnter = _this.handleTargetMouseEnter.bind(_this), _this.handleTargetMouseLeave = _this.handleTargetMouseLeave.bind(_this), _this.handlePopperMouseEnter = _this.handlePopperMouseEnter.bind(_this), _this.handlePopperMouseLeave = _this.handlePopperMouseLeave.bind(_this), _this;
  }

  return _inherits(Tooltip, _PureComponent), _createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      void 0 === this.props.theme.vstui.fontFamily && (this.theme = (0, _themes.createTheme)()), document.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearOpenTimeout(), this.clearCloseTimeout(), document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur() {
      this.close();
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus() {
      this.delayedOpen();
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      var open = this.state.open;
      open && event.which === 27 && this.close();
    }
  }, {
    key: 'handleTargetMouseEnter',
    value: function handleTargetMouseEnter(event) {
      event.target.disabled || this.delayedOpen();
    }
  }, {
    key: 'handleTargetMouseLeave',
    value: function handleTargetMouseLeave() {
      this.delayedClose();
    }
  }, {
    key: 'handlePopperMouseEnter',
    value: function handlePopperMouseEnter() {
      this.clearCloseTimeout();
    }
  }, {
    key: 'handlePopperMouseLeave',
    value: function handlePopperMouseLeave() {
      this.delayedClose();
    }
  }, {
    key: 'clearOpenTimeout',
    value: function clearOpenTimeout() {
      clearTimeout(this.openTimeout), this.openTimeout = null;
    }
  }, {
    key: 'clearCloseTimeout',
    value: function clearCloseTimeout() {
      clearTimeout(this.closeTimeout), this.closeTimeout = null;
    }
  }, {
    key: 'delayedOpen',
    value: function delayedOpen() {
      var _this2 = this,
          open = this.state.open;

      this.clearOpenTimeout(), this.clearCloseTimeout(), open || (this.openTimeout = setTimeout(function () {
        _this2.setState({
          open: !0
        });
      }, 500));
    }
  }, {
    key: 'close',
    value: function close() {
      this.clearOpenTimeout(), this.clearCloseTimeout(), this.setState({
        open: !1
      });
    }
  }, {
    key: 'delayedClose',
    value: function delayedClose() {
      var _this3 = this;

      this.clearOpenTimeout(), this.clearCloseTimeout(), this.closeTimeout = setTimeout(function () {
        _this3.setState({
          open: !1
        });
      }, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this,
          _props = this.props,
          children = _props.children,
          className = _props.className,
          id = _props.id,
          inheritStyles = _props.inheritStyles,
          placement = _props.placement,
          themeProp = _props.theme,
          title = _props.title,
          theme = (0, _componentTheme2.default)(themeProp),
          offset = 4;

      return _react2.default.createElement(Styled.Manager, {
        className: className,
        style: inheritStyles ? {} : _styles.resetInheritedStylesObject,
        tag: 'div'
      }, _react2.default.createElement(_reactPopper.Target, null, function (_ref) {
        var targetProps = _ref.targetProps;
        return _react2.default.cloneElement(children, {
          innerRef: targetProps.ref,
          onBlur: _this4.handleBlur,
          onFocus: _this4.handleFocus,
          onMouseEnter: _this4.handleTargetMouseEnter,
          onMouseLeave: _this4.handleTargetMouseLeave
        });
      }), _react2.default.createElement(_reactPopper.Popper, {
        modifiers: {
          offset: {
            offset: '0, ' + offset + 'px'
          }
        },
        placement: placement
      }, function (_ref2) {
        var popperProps = _ref2.popperProps,
            open = _this4.state.open,
            style = popperProps.style,
            otherProps = _objectWithoutProperties(popperProps, ['style']);

        style.pointerEvents = open ? 'auto' : 'none', style.cursor = 'default', style.zIndex = theme.vstui.Tooltip_zIndex;
        var conditionalProps = open ? otherProps : {};
        return _react2.default.createElement('div', _extends({}, conditionalProps, {
          "aria-hidden": 'true',
          id: id,
          onMouseEnter: _this4.handlePopperMouseEnter,
          onMouseLeave: _this4.handlePopperMouseLeave,
          role: 'tooltip',
          style: style
        }), _react2.default.createElement('div', {
          style: {
            position: 'absolute',
            top: '-' + offset + 'px',
            right: '-' + offset + 'px',
            bottom: '-' + offset + 'px',
            left: '-' + offset + 'px'
          }
        }), _react2.default.createElement(Styled.div.tooltip, {
          sc: {
            open: open,
            placement: popperProps['data-placement'] || ''
          },
          theme: theme
        }, title));
      }));
    }
  }]), Tooltip;
}(_react.PureComponent);

Tooltip.propTypes = {
  children: _propTypes2.default.element.isRequired,
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  inheritStyles: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  open: _propTypes2.default.bool,
  placement: _propTypes2.default.oneOf(['auto', 'top', 'right', 'bottom', 'left', 'auto-start', 'top-start', 'right-start', 'bottom-start', 'left-start', 'auto-end', 'top-end', 'right-end', 'bottom-end', 'left-end']),
  theme: _propTypes3.themeShape
}, Tooltip.defaultProps = {
  theme: {
    vstui: {}
  }
}, Tooltip.displayName = Tooltip;
var TooltipWithTheme = (0, _themes.withTheme)(Tooltip);
TooltipWithTheme.WrappedComponent = Tooltip, exports.default = TooltipWithTheme;